import axios from "axios";

import {
  CLAIM_WARRANTY_FAILURE,
  CLAIM_WARRANTY_REQUEST,
  CLAIM_WARRANTY_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DELIVER_FAIL,
  ORDER_DELIVER_REQUEST,
  ORDER_DELIVER_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_LIST_FAIL,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_MY_LIST_FAIL,
  ORDER_MY_LIST_REQUEST,
  ORDER_MY_LIST_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_STATS_FAIL,
  ORDER_STATS_REQUEST,
  ORDER_STATS_SUCCESS,
  ORDER_STATUS_FAIL,
  ORDER_STATUS_REQUEST,
  ORDER_STATUS_SUCCESS,
  USER_WARRANTY_CLAIMS_FAILURE,
  USER_WARRANTY_CLAIMS_REQUEST,
  USER_WARRANTY_CLAIMS_SUCCESS,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_SUCCESS,
  ORDER_CANCEL_FAIL,
  ORDER_DELETE_REQUEST,
  ORDER_DELETE_SUCCESS,
  ORDER_DELETE_FAIL,
  CLAIM_STATUS_FAIL,
  CLAIM_STATUS_REQUEST,
  CLAIM_STATUS_SUCCESS,
} from "../constants/orderConstants";
import { serverIp } from "../config/conf";

export const createOrder = (order) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(`${serverIp}/api/orders`, order, config);

    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const getOrderDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${serverIp}/api/orders/${id}`, config);

    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

// export const payOrder =
//   (orderId, paymentResult) => async (dispatch, getState) => {
//     try {
//       dispatch({ type: ORDER_PAY_REQUEST });

//       const {
//         userLogin: { userInfo },
//       } = getState();

//       const config = {
//         headers: {
//           Authorization: `Bearer ${userInfo.token}`,
//           "Content-Type": "application/json",
//         },
//       };

//       const { data } = await axios.put(
//         `${serverIp}/api/orders/${orderId}/pay`,
//         paymentResult,
//         config
//       );

//       dispatch({ type: ORDER_PAY_SUCCESS, payload: data });
//     } catch (err) {
//       dispatch({
//         type: ORDER_PAY_FAIL,
//         payload:
//           err.response && err.response.data.message
//             ? err.response.data.message
//             : err.message,
//       });
//     }
//   };

export const listMyOrders = (state) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_MY_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${serverIp}/api/orders/myorders?status=${state}`,
      config
    );

    dispatch({ type: ORDER_MY_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ORDER_MY_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const listOrders = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${serverIp}/api/orders`,
      config
    );

    dispatch({ type: ORDER_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ORDER_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const deliverOrder = (order) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_DELIVER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${serverIp}/api/orders/${order._id}/deliver`,
      order,
      config
    );

    dispatch({ type: ORDER_DELIVER_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ORDER_DELIVER_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};

export const updateOrderStatus =
  (id, status, isPaid) => async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_STATUS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${serverIp}/api/orders/${id}/status`,
        { status, isPaid },
        config
      );

      dispatch({ type: ORDER_STATUS_SUCCESS, payload: data });
    } catch (err) {
      dispatch({
        type: ORDER_STATUS_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

export const getOrderStats =
  (startDate, endDate, state, sortFor, sortTo) =>
    async (dispatch, getState) => {
      try {
        dispatch({ type: ORDER_STATS_REQUEST });

        const {
          userLogin: { userInfo },
        } = getState();

        const config = {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
            "Content-Type": "application/json",
          },
        };

        const params = new URLSearchParams({
          startDate: startDate.toString(), // or toISOString() if backend supports it
          endDate: endDate.toString(),
          status: state,           // e.g., "all", "Pending"
          sortFor: sortFor,        // e.g., "createdAt"
          sortTo: sortTo.toString() // true/false
        });

        console.log(`${serverIp}/api/orders/stats?${params.toString()}`);

        // const { data } = await axios.get(
        //   `${serverIp}/api/orders/stats?startDate=${startDate}&endDate=${endDate}&status=${state}&sortFor=${sortFor}&sortTo=${sortTo}`,
        //   config
        // );
        const { data } = await axios.get(
          `${serverIp}/api/orders/stats?${params.toString()}`,
          config
        );

        dispatch({
          type: ORDER_STATS_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: ORDER_STATS_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        });
      }
    };

export const claimWarranty =
  (orderId, productId, variantId, claimMessage, photos) =>
    async (dispatch, getState) => {
      try {
        dispatch({ type: CLAIM_WARRANTY_REQUEST });

        const {
          userLogin: { userInfo },
        } = getState();

        const config = {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
            "Content-Type": "application/json",
          },
        };

        // Make the API request to claim warranty
        const response = await axios.post(
          `${serverIp}/api/claims/${orderId}/claim-warranty`,
          {
            productId,
            variantId,
            claimMessage,
            photos,
          },
          config
        );

        dispatch({
          type: CLAIM_WARRANTY_SUCCESS,
          payload: response.data,
        });
      } catch (error) {
        dispatch({
          type: CLAIM_WARRANTY_FAILURE,
          payload: error.response ? error.response.data : "Network error",
        });
      }
    };

export const getUserWarrantyClaims = (isAdmin) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_WARRANTY_CLAIMS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    // Make the API request to claim warranty
    const response = await axios.get(
      `${serverIp}/api/claims/${isAdmin ? "" : "my-"}warranty-claims`,
      config
    );

    dispatch({
      type: USER_WARRANTY_CLAIMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: USER_WARRANTY_CLAIMS_FAILURE,
      payload: error.response ? error.response.data : "Network error",
    });
  }
};


export const updateWarrantyClaimsStatus =
  (id, status, message) => async (dispatch, getState) => {
    try {
      dispatch({ type: CLAIM_STATUS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${serverIp}/api/claims/${id}/status`,
        { status, message },
        config
      );

      dispatch({ type: CLAIM_STATUS_SUCCESS, payload: data });
    } catch (err) {
      dispatch({
        type: CLAIM_STATUS_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };


export const cancelOrder = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_CANCEL_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${serverIp}/api/orders/${id}/cancel`,
      {},
      config
    );

    dispatch({ type: ORDER_CANCEL_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ORDER_CANCEL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const deleteOrder = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.delete(`${serverIp}/api/orders/${id}/delete`, config);

    dispatch({ type: ORDER_DELETE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ORDER_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

